import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'preventNegative',
})
export class PreventNegativePipe implements PipeTransform {
  transform(value: number): number {
    return Math.max(0, value);
  }
}
